import React from 'react';
import { useParams } from 'react-router-dom';
import RecruitmentPlanJobList from './RecruitmentPlanJobList';

const RecruitmentPlanJobPromList = () => {

    const { planIdParam } = useParams();

    return (
        <RecruitmentPlanJobList recuitmentPlanId={planIdParam} type="PROMOVARE_CONDUCERE"/>
    );
};

export default RecruitmentPlanJobPromList;
